import React from 'react';
import PencilAltIcon from '@heroicons/react/outline/PencilAltIcon.js';
import { BlockType } from '../../types/index.js';
import { PostComposerBlock as Component } from './Block.js';
import { PostComposerBlockSettings as Settings } from './Settings.js';
export const RegisteredPostComposerBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'PostComposer',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({
                id: 'Blocks.PostComposer.DisplayName',
                defaultMessage: 'Composer',
            }),
            Settings,
            Icon: React.createElement(PencilAltIcon, null),
            defaultProps: {
                buttons: [],
            },
        },
    };
};
//# sourceMappingURL=registered.js.map